import { ApiKeys } from '@app/constants/api-keys'
import { IEducationGroupType } from '@app/interfaces/education/education-group-type'
import { resolveTParams } from '@app/utils/resolve-params/resolve-params'
import localforage from 'localforage'
import { IRtkResponse } from '../../types'
import { emptyEducationApi } from './index'

export const educationGroupTypeApi = emptyEducationApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (build) => ({
    getEducationGroupTypes: build.query<
      IRtkResponse<IEducationGroupType[]>,
      URLSearchParams | string
    >({
      query: (args = '') => ({
        url: 'education/api/v1/education-group-type-dictionary',
        method: 'get',
        params: {
          ...resolveTParams(args),
        },
      }),
      transformResponse: (response: IEducationGroupType[], meta) => {
        return { response, meta }
      },
      providesTags: (data) =>
        data
          ? [
              ...data.response.map(({ id }) => ({
                type: ApiKeys.educationGroupType,
                id,
              })),
              { type: ApiKeys.educationGroupType, id: 'LIST' },
            ]
          : [{ type: ApiKeys.educationGroupType, id: 'LIST' }],
      async onQueryStarted(args, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          localforage.setItem(ApiKeys.educationGroupType, data?.response)
        } catch (e) {
          console.error(e)
        }
      },
    }),
    getEducationGroupType: build.query<IEducationGroupType, number>({
      query: (id) => ({
        url: `education/api/v1/education-group-type-dictionary/${id}`,
        method: 'get',
      }),
      providesTags: (result, error, id) => [
        { type: ApiKeys.educationGroupType, id },
      ],
    }),
  }),
})

export const { useGetEducationGroupTypesQuery, useGetEducationGroupTypeQuery } =
  educationGroupTypeApi
